import _ from 'lodash'

const animations = {
  namespaced: true,
  state: {
    windowScrollY: 0,
    oldRoutePosition: 0,
    oldRouteName: undefined,
    mouseCursor: 'default',
    mouseCursorData: [],
    pixiApps: []
  },
  getters: {
    windowScrollPosition: state => state.windowScrollY,
    mouseCursor: state => state.mouseCursor,
    mouseCursorData: state => state.mouseCursorData,
    oldRoutePosition: state => state.oldRoutePosition,
    oldRouteName: state => state.oldRouteName
  },
  mutations: {
    updateScrollPosition (state, position) {
      state.windowScrollY = position
    },
    updateMouseCursor (state, type) {
      state.mouseCursor = type
    },
    updateMouseCursorPayload (state, data) {
      state.mouseCursorData = data
    },
    addPixiApp (state, app) {
      state.pixiApps = _.concat(state.pixiApps, app)
    },
    destroyPixiApps (state) {
      _.forEach(state.pixiApps, app => app.destroy())
      state.pixiApps = []
    },
    updateOldRoutePosition (state, position) {
      state.oldRoutePosition = position
    },
    updateOldRouteName (state, name) {
      state.oldRouteName = name
    }
  }
}

export default animations
